(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/templates/tabbed/assets/javascripts/sticky-menu.js') >= 0) return;  svs.modules.push('/templates/tabbed/assets/javascripts/sticky-menu.js');
"use strict";


const getNumber = str => Number((str.match(/^(\d+)px$/) || [])[1]);
const templateConfig = svs.tabbed.data.templateConfig;
const SCREEN_SM = 480;
const initStickyMenu = () => {
  const queryList = matchMedia("(max-width:".concat(SCREEN_SM, "px)"));
  const tabbedNav = document.querySelector('.js-tabbed-nav');
  const previousBreadcrumbLink = document.querySelector('.previous-crumb-link');
  const updateMatch = () => {
    const nextElement = tabbedNav.nextElementSibling;
    let mainElement;
    let initialPaddingBottom = 0;
    if (nextElement) {
      mainElement = nextElement.classList.contains('top-breadcrumbs') ? nextElement.nextElementSibling : nextElement;
      initialPaddingBottom = getNumber(getComputedStyle(mainElement).paddingBottom);
    }
    const tabbedNavStyle = getComputedStyle(tabbedNav);
    const shadowHeight = getNumber(tabbedNavStyle.getPropertyValue('--drop-shadow-y-offset'));
    const hasStaticBottomBreadcrumb = previousBreadcrumbLink && previousBreadcrumbLink.classList.contains('static');
    if (queryList.matches) {
      const calculatedHeight = "".concat(Number(initialPaddingBottom) + shadowHeight + tabbedNav.offsetHeight, "px");
      if (hasStaticBottomBreadcrumb) {
        previousBreadcrumbLink.parentElement.style.paddingBottom = calculatedHeight;
      } else {
        mainElement && (mainElement.style.paddingBottom = calculatedHeight);
        if (previousBreadcrumbLink) {
          previousBreadcrumbLink.style.marginBottom = calculatedHeight;
        }
      }
    } else {
      mainElement && (mainElement.style.paddingBottom = null);
      if (previousBreadcrumbLink) {
        previousBreadcrumbLink.style.marginBottom = null;
        previousBreadcrumbLink.parentElement.style.paddingBottom = null;
      }
    }
  };
  queryList.addListener(updateMatch);
  updateMatch();
};
if (templateConfig.isSticky) {
  initStickyMenu();
}

 })(window);